import { atom } from 'jotai';
export const isVideoLabelingM4EnabledAtom = atom(false);
export const taskQuestionnaireStatusAtom = atom<'PENDING' | 'DONE' | 'OPTIONAL' | undefined>(undefined);